<template>
  <v-card class="card-pad pa-0 pb-2 mt-4">
    <div>
      <v-dialog v-model="removeMetricModal" max-width="300">
        <div class="text-center">
          <v-sheet
            class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
            color="blue-grey darken-3"
            dark
          >
            <div class="grey--text text--lighten-1 text-body-2 mb-4">
              {{ $t('Tem certeza de que deseja excluir este métrica?') }}
            </div>

            <v-btn
              :disabled="removeMetricLoading"
              class="ma-1"
              color="grey"
              text
              @click="removeMetricModal = false"
            >
              Cancelar
            </v-btn>

            <v-btn
              :loading="removeMetricLoading"
              class="ma-1"
              color="error"
              text
              @click="removeMetric"
            >
              {{ $t('Excluir') }}
            </v-btn>
          </v-sheet>
        </div>
      </v-dialog>

      <v-dialog v-model="deleteRangeModal" max-width="300px">
        <div class="text-center">
          <v-sheet
            class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
            color="blue-grey darken-3"
            dark
          >
            <div class="grey--text text--lighten-1 text-body-2 mb-4">
              {{ $t('Tem certeza de que deseja excluir este ponto?') }}
            </div>

            <v-btn
              :disabled="deleteLoading"
              class="ma-1"
              color="grey"
              text
              @click="deleteRangeModal = false"
            >
              Cancelar
            </v-btn>

            <v-btn
              :loading="deleteLoading"
              class="ma-1"
              color="error"
              text
              @click="removeMetricRange"
            >
              {{ $t('Excluir') }}
            </v-btn>
          </v-sheet>
        </div>
      </v-dialog>

      <v-dialog v-model="rangeModal" max-width="500">
        <ManageRange
          :selectedRange="selectedRange"
          :metricId="metricId"
          :key="rangeModalKey"
          @close="rangeModal = false"
          @confirm="reloadAndClose"
        />
      </v-dialog>

      <v-dialog v-model="manageMetricModal" max-width="500">
        <ManageMetric
          :metricId="metricId"
          :patternId="patternId"
          :key="manageMetricModalKey"
          @close="manageMetricModal = false"
          @confirm="reloadAndClose"
        />
      </v-dialog>

      <div class="px-4 py-3">
        <v-row class="ma-0" dense justify="end">
          <v-col class="d-flex align-center">
            <strong> Métricas </strong>
            <v-spacer></v-spacer>
            <v-btn
              class="primary-button mr-0"
              depressed
              @click="openAddMetricModal"
            >
              Nova métrica
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-divider />

      <div class="text-center pa-4">
        <div class="text-center">
          <strong v-if="metrics.length == 0">Nenhuma métrica encontrada</strong>

          <v-simple-table class="main-table" v-else>
            <thead>
              <tr>
                <th class="text-center"></th>
                <th class="text-center">Métrica</th>
                <th class="text-center">Resolução</th>
                <th class="text-center">Pontos</th>
                <th class="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in metrics" :key="item.id">
                <td class="text-center"></td>
                <td class="text-center">
                  {{ item.metric ? item.metric.name : '' }}
                </td>
                <td class="text-center">
                  <h3>{{ item.resolution }}</h3>
                </td>
                <td class="text-center">
                  <v-btn
                    class="mr-0 mt-4"
                    color="primary"
                    depressed
                    @click.stop="openAddRange(item.id)"
                    block
                  >
                    <strong> Novo ponto </strong>
                    <v-icon class="ml-2 mb-1">mdi-plus</v-icon>
                  </v-btn>

                  <strong
                    class="font-weight-bold"
                    v-if="item.ranges && item.ranges.length == 0"
                  >
                    <div class="my-3">Nenhum ponto encontrado</div>
                  </strong>

                  <v-simple-table class="main-table" v-else>
                    <thead>
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center">Ponto</th>
                        <th class="text-center">K</th>
                        <th class="text-center">Incerteza</th>
                        <th class="text-center">Tendência</th>
                        <th class="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="range in item.ranges" :key="range.id">
                        <td></td>
                        <td>{{ range.range }}</td>
                        <td>{{ range.k }}</td>
                        <td>{{ range.uncertainty }}</td>
                        <td>{{ range.tendency }}</td>
                        <td>
                          <v-btn
                            fab
                            tile
                            style="border-radius: 9px"
                            depressed
                            class="ma-1 mb-2"
                            x-small
                            color="primary"
                            @click.stop="openEditRange(range)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>

                          <v-btn
                            fab
                            tile
                            style="border-radius: 9px"
                            depressed
                            class="ma-1 mb-2"
                            x-small
                            color="error"
                            @click.stop="openRemoveModal(range.id)"
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
                <td>
                  <v-btn
                    color="primary"
                    depressed
                    small
                    @click="openEditMetric(item)"
                  >
                    editar
                  </v-btn>
                  <br />
                  <v-btn
                    @click="openRemoveMetricModal(item)"
                    color="error"
                    depressed
                    small
                  >
                    Remover
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import ManageMetric from './manageMetric.vue'
import ManageRange from './manageRange.vue'

export default {
  name: 'PatternMetricsV2',

  data() {
    return {
      removeMetricLoading: false,
      removeMetricModal: false,
      selectedRange: {},
      manageMetricModalKey: false,
      manageMetricModal: false,
      metrics: [],
      filter: {
        patternId: null,
        page: 1,
        pageSize: 10,
      },
      apiService: new ApiService(),
      patternId: null,
      rangeModal: false,
      rangeModalKey: false,
      metricId: false,
      deleteLoading: false,
      deleteRangeModal: false,
      rangeId: null,
    }
  },

  components: {
    ManageMetric,
    ManageRange,
  },

  created() {
    this.patternId = this.$route.query.id
    this.list()
  },

  methods: {
    removeMetric() {
      this.removeMetricLoading = true
      this.apiService
        .delete(`calibration/v2/pattern/metric/${this.parameterId}`)
        .then(() => {
          this.filter.page = 1
          this.removeMetricLoading = false
          this.removeMetricModal = false
          this.$toast.success('Template removido com sucesso!')
          this.list()
        })
        .catch(() => {
          this.removeMetricLoading = false
        })
    },

    openRemoveMetricModal(item) {
      this.parameterId = item.id
      this.removeMetricModal = true
    },

    openRemoveModal(id) {
      this.rangeId = id
      this.deleteRangeModal = true
    },

    removeMetricRange() {
      this.deleteLoading = true
      this.apiService
        .delete('calibration/v2/pattern/metric/range/' + this.rangeId)
        .then((response) => {
          this.$toast.success('Ponto removido com sucesso!')
          this.deleteRangeModal = false
          this.deleteLoading = false
          this.reloadAndClose()
        })
        .catch(() => {
          this.deleteLoading = false
        })
    },

    openAddMetricModal() {
      this.metricId = null
      this.manageMetricModalKey = !this.manageMetricModalKey
      this.manageMetricModal = true
    },

    openEditMetric(item) {
      this.metricId = item.id
      this.manageMetricModalKey = !this.manageMetricModalKey
      this.manageMetricModal = true
    },

    openEditRange(item) {
      this.selectedRange = item
      this.metricId = item.id
      this.rangeModalKey = !this.rangeModalKey
      this.rangeModal = true
    },

    openAddRange(id) {
      this.selectedRange = null
      this.metricId = id
      this.rangeModalKey = !this.rangeModalKey
      this.rangeModal = true
    },

    reloadAndClose() {
      this.manageMetricModal = false
      this.manageMetricModalKey = !this.manageMetricModalKey

      this.rangeModal = false
      this.rangeModalKey = !this.rangeModalKey

      this.filter.page = 1
      this.list()
    },

    list() {
      const id = this.$route.query.id

      if (id) this.filter.patternId = id

      this.apiService
        .get('calibration/v2/pattern/metric/paginate', this.filter)
        .then((response) => {
          this.metrics = response.content.data
        })
    },
  },
}
</script>

<style></style>
